@if (showUploadInfo) {
  <div class="upload-info" [@UploadInfo]>
    <!-- Header -->
    <div class="upload-info-header" [class.clickable]="!gallery" (click)="headerClick()">
      <!-- Header icon-->
      <div class="upload-info-icon">
        <app-svg src="/assets/icons/spinner.svg" class="spinner"></app-svg>
      </div>
      <!-- Header meta - Gallery view -->
      @if (gallery) {
        <div class="upload-meta">
          @if (remainingUploadCount) {
            <h3>
              Uploading {{ remainingUploadCount }} of {{ uploads.length }}
              @if (uploads.length !== 1) {
                assets
              } @else {
                asset
              }
            </h3>
            <div>{{ stats().remainingSize | dataUnitsBigInt }} remaining</div>
          }
          @if (!remainingUploadCount) {
            <h3>Finishing asset processing</h3>
            <div>Wrapping things up</div>
          }
        </div>
      }
      <!-- Header meta - Non gallery view -->
      @if (!gallery) {
        <div class="upload-meta">
          <h3>
            Uploading {{ galleries.length }}
            @if (galleries.length === 1) {
              Gallery
            } @else {
              Galleries
            }
          </h3>
          <div>{{ stats().totalUploadSize | dataUnitsBigInt }}</div>
        </div>
      }
      <!-- Header actions -->
      @if (showMinimize) {
        <button
          appButton
          name="toggle-minimize"
          location="upload-info"
          [iconButton]="true"
          spacing="1"
          color="simple-gray"
          height="1"
          (click)="toggleMinimized()"
          class="toggle-button"
          id="upload-info-toggle"
          [class.flipped]="minimized"
        >
          <app-svg src="/assets/icons/stroke/arrow-down.svg"></app-svg>
        </button>
      }
      @if (!onGalleryPage) {
        <button
          appButton
          name="go-to-gallery"
          location="upload-info"
          [iconButton]="true"
          spacing="1"
          color="simple-gray"
          height="1"
        >
          <app-svg src="/assets/icons/stroke/arrow-right.svg"></app-svg>
        </button>
      }
      @if (showMoreMenu) {
        <app-context-menu [options]="{ noSpacing: true, width: '200px' }" [position]="'right'" #menu>
          <button
            appButton
            name="options"
            location="upload-info"
            [iconButton]="true"
            spacing="1"
            color="simple-gray"
            height="1"
            class="menu-dots"
            contextButton
          >
            <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
          </button>
          <div contextContent>
            <div class="button-menu">
              <app-button-menu-item
                name="cancel-upload"
                location="upload-info"
                color="simple-warn"
                icon="stop"
                (click)="menu.close(); showCancelUploadDialog()"
                >Cancel Upload</app-button-menu-item
              >
            </div>
          </div>
        </app-context-menu>
      }
    </div>
    <!-- Progress bar -->
    <div class="upload-progress">
      <div class="upload-progress-inner" [style.width]="'calc(' + uploadProgressPercent + '%)'"></div>
    </div>
    <!-- Content - Gallery view -->
    @if (!minimized && gallery) {
      <div class="upload-process-content" [@uploadContent]>
        @if (failedUploads.length) {
          <div class="upload-error-info" (click)="showFailedUploads()">
            <app-svg src="/assets/icons/alert.svg"></app-svg>
            <span
              >{{ failedUploads.length }} Failed
              @if (failedUploads.length !== 1) {
                Uploads
              } @else {
                Upload
              }
            </span>
            <span>Show Details</span>
          </div>
        }
        <div class="upload-process-content-inner">
          @for (upload of uploads | uploadOrder; track upload.id; let i = $index) {
            <app-upload-item
              [@uploadItem]
              [upload]="upload"
              [generatePreview]="!upload.cancelled"
              [gallery]="gallery"
              (onDismissError)="dismissError(upload)"
            >
            </app-upload-item>
          }
        </div>
        @if (galleries.length > 1) {
          <div class="upload-footer">
            <span>Uploading {{ galleries.length }} Galleries</span>
            <button
              appButton
              name="upload-info-view-all-galleries"
              location="upload-info"
              [iconButton]="true"
              spacing="1"
              color="simple-gray"
              height="0"
              (click)="switchToGalleries()"
              class="toggle-button"
            >
              <app-svg src="/assets/icons/stroke/arrow-right.svg"></app-svg>
            </button>
          </div>
        }
      </div>
    }
    <!-- Content - Expanded gallery view -->
    @if (!minimized && !gallery) {
      <div class="upload-process-content" [@uploadContent]>
        @if (!gallery) {
          <div class="upload-process-content-inner">
            @for (gallery of galleries; track gallery) {
              <a [routerLink]="['/a', 'gallery', gallery.id | removeIdPrefix, 'designer']">
                <app-upload-item
                  [upload]="galleryAsUpload(gallery)"
                  [generatePreview]="true"
                  class="gallery-item"
                  [gallery]="gallery"
                >
                </app-upload-item>
              </a>
            }
          </div>
        }
      </div>
    }
  </div>
}
<!-- upload success -->
@if (showUploadDone) {
  <div class="upload-info upload-done-info" [@UploadInfo] [class.raised]="showUploadInfo">
    <button
      appButton
      name="success-close"
      location="upload-info"
      [iconButton]="true"
      spacing="1"
      color="simple-gray"
      height="1"
      class="close-button"
      (click)="close()"
    >
      <app-svg src="/assets/icons/cross.svg"></app-svg>
    </button>
    <div class="success-icon">
      <img src="/assets/animations/checkmark.svg" alt="" />
    </div>
    <div class="success-info">
      <h3>Upload completed!</h3>
      <h4>
        {{ uploadedAssetCount }}
        @if (uploadedAssetCount !== 1) {
          assets,
        } @else {
          asset,
        }
        {{ uploadedTotalSize | dataUnitsBigInt }}
      </h4>
    </div>
    @if (failedUploads.length) {
      <div class="failed-uploads" (click)="showFailedUploads()">
        <app-svg src="/assets/icons/alert.svg"></app-svg>
        <span>{{ failedUploads.length }} failed (<span class="view-failed-link">show details</span>)</span>
      </div>
    }
    <div class="success-buttons">
      <button
        appButton
        name="success-settings"
        location="upload-info"
        [hasIcon]="true"
        spacing="full"
        class="first-button"
        (click)="openGallerySettingsDialog()"
      >
        <app-svg src="/assets/icons/gear.svg"></app-svg>
        <span>Settings</span>
      </button>
      <button
        appButton
        name="success-share"
        location="upload-info"
        color="primary"
        weight="bold"
        [hasIcon]="true"
        spacing="full"
        (click)="openShareDialog()"
      >
        <app-svg src="/assets/icons/forward.svg"></app-svg>
        <span>Share</span>
      </button>
    </div>
  </div>
}
<!-- upload failed -->
@if (showUploadFailed) {
  <div class="upload-info upload-done-info" [@UploadInfo] [class.raised]="showUploadInfo">
    <button
      appButton
      name="failed-close"
      location="upload-info"
      [iconButton]="true"
      spacing="1"
      color="simple-gray"
      height="1"
      class="close-button"
      (click)="close()"
    >
      <app-svg src="/assets/icons/cross.svg"></app-svg>
    </button>
    <div class="warning-icon">
      <app-svg src="/assets/icons/64/alert.svg"></app-svg>
    </div>
    <div class="success-info">
      <h3>Upload Failed!</h3>
      @if (failedUploads.length > 1) {
        <h4>There were {{ failedUploads.length }} unsuccessful uploads.</h4>
      } @else {
        <h4>There was 1 unsuccessful upload.</h4>
      }
    </div>
    <div class="success-buttons">
      <button appButton name="failed-details" location="upload-info" spacing="full" (click)="showFailedUploads()">
        <span>Show details</span>
      </button>
      <button
        appButton
        name="failed-dismiss"
        location="upload-info"
        color="primary"
        weight="bold"
        spacing="full"
        (click)="close()"
      >
        <span>Dismiss</span>
      </button>
    </div>
  </div>
}
